import { render, staticRenderFns } from "./relatorioFinanceiroCapitalAplicadoXRentabilidade.vue?vue&type=template&id=594d4ae7"
import script from "./relatorioFinanceiroCapitalAplicadoXRentabilidade.vue?vue&type=script&lang=js"
export * from "./relatorioFinanceiroCapitalAplicadoXRentabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports